import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { adminApi } from '@formosa/shared/api/admin';
import {
  getDefaultPlayType,
  isPlayTypeTabDisabled,
  PLAY_TYPE_TABS,
} from './controlConstants';
import { OrderControlGlobalPanel, OrderControlPersonalPanel } from './OrderControlPanels';

export default function OrderControlManagePage({ mode, title }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabCounts, setTabCounts] = useState({});
  const [countsLoaded, setCountsLoaded] = useState(false);

  const playTypeFromUrl = searchParams.get('playType');
  const activePlayType = useMemo(() => {
    if (playTypeFromUrl && PLAY_TYPE_TABS.some((tab) => tab.key === playTypeFromUrl)) {
      return playTypeFromUrl;
    }
    return getDefaultPlayType(tabCounts);
  }, [playTypeFromUrl, tabCounts]);

  const loadTabCounts = useCallback(async () => {
    try {
      const data = await adminApi.orderProductPage({ pageNo: 1, pageSize: 1 });
      setTabCounts(data?.tabCounts || {});
    } catch {
      setTabCounts({});
    } finally {
      setCountsLoaded(true);
    }
  }, []);

  useEffect(() => {
    loadTabCounts();
  }, [loadTabCounts]);

  useEffect(() => {
    if (!countsLoaded) {
      return;
    }
    if (!playTypeFromUrl || !PLAY_TYPE_TABS.some((tab) => tab.key === playTypeFromUrl)) {
      setSearchParams({ playType: getDefaultPlayType(tabCounts) }, { replace: true });
    }
  }, [countsLoaded, playTypeFromUrl, setSearchParams, tabCounts]);

  function handlePlayTypeChange(nextPlayType) {
    if (isPlayTypeTabDisabled(nextPlayType, tabCounts)) {
      return;
    }
    setSearchParams({ playType: nextPlayType });
  }

  return (
    <div className="page-card order-control-page">
      <h2>{title}</h2>

      <div className="product-tabs">
        {PLAY_TYPE_TABS.map((tab) => {
          const disabled = isPlayTypeTabDisabled(tab.key, tabCounts);
          return (
            <button
              key={tab.key}
              type="button"
              className={`product-tabs__item ${activePlayType === tab.key ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}
              onClick={() => handlePlayTypeChange(tab.key)}
              disabled={disabled}
            >
              {tab.label}
              {countsLoaded && tabCounts[tab.key] != null ? ` (${tabCounts[tab.key]})` : ''}
            </button>
          );
        })}
      </div>

      {mode === 'personal' ? (
        <OrderControlPersonalPanel playType={activePlayType} />
      ) : (
        <OrderControlGlobalPanel playType={activePlayType} />
      )}
    </div>
  );
}
